import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TabViewModule } from "primeng/tabview";
import { TreeModule } from "primeng/tree";
import { ChaseGridModule } from "../../../shared/chase-grid/chase-grid.module";
import { SharedModule } from "../../../shared/shared.module";
import { AuditPageEntryService } from "../member/chase-detail/chase-detail-chart/audit-page-entry/audit-page-entry.service";
import { ChaseDetailStateService } from "../member/chase-detail/chase-detail-state.service";
import { MemberModule } from "../member/member.module";
import { AuditPackageGenerateComponent } from "./audit-query/audit-query-quality/audit-package-generate/audit-package-generate.component";
import { AuditPackageGenerateService } from "./audit-query/audit-query-quality/audit-package-generate/audit-package-generate.service";
import { AuditQueryChartComponent } from "./audit-query/audit-query-quality/audit-query-chart/audit-query-chart.component";
import { AuditQueryChartService } from "./audit-query/audit-query-quality/audit-query-chart/audit-query-chart.service";
import { AuditQueryGridActionComponent } from "./audit-query/audit-query-quality/audit-query-grid-action/audit-query-grid-action.component";
import { AuditQueryGridComponent } from "./audit-query/audit-query-quality/audit-query-grid/audit-query-grid.component";
import { AuditQueryGridService } from "./audit-query/audit-query-quality/audit-query-grid/audit-query-grid.service";
import { AuditPackageGenerateRiskComponent } from "./audit-query/audit-query-risk/audit-package-generate-risk/audit-package-generate-risk.component";
import { AuditPackageGenerateRiskService } from "./audit-query/audit-query-risk/audit-package-generate-risk/audit-package-generate-risk.service";
import { AuditQueryChartRiskComponent } from "./audit-query/audit-query-risk/audit-query-chart-risk/audit-query-chart-risk.component";
import { AuditQueryGridActionRiskComponent } from "./audit-query/audit-query-risk/audit-query-grid-action-risk/audit-query-grid-action-risk.component";
import { AuditQueryGridRiskComponent } from "./audit-query/audit-query-risk/audit-query-grid-risk/audit-query-grid-risk.component";
import { AuditQueryItemUserRankRiskComponent } from "./audit-query/audit-query-risk/audit-query-item-user-rank-risk/audit-query-item-user-rank-risk.component";
import { AuditQueryGridFiltersComponent } from "./audit-query/audit-query-shared/audit-query-grid-filters/audit-query-grid-filters.component";
import { AuditQueryGridFiltersService } from "./audit-query/audit-query-shared/audit-query-grid-filters/audit-query-grid-filters.service";
import { AuditQueryHeaderComponent } from "./audit-query/audit-query-shared/audit-query-header/audit-query-header.component";
import { AuditQueryHeaderService } from "./audit-query/audit-query-shared/audit-query-header/audit-query-header.service";
import { AuditQueryItemReadinessComponent } from "./audit-query/audit-query-shared/audit-query-item-readiness/audit-query-item-readiness.component";
import { AuditQueryComponent } from "./audit-query/audit-query.component";
import { AuditRoutingModule } from "./audit-routing.module";
import { AuditService } from "./audit.service";

@NgModule({
  imports: [
    AuditRoutingModule,
    ChaseGridModule,
    SharedModule,
    FormsModule, // TODO: Remove when forms are done.
    TreeModule,
    MemberModule,
    TabViewModule,
  ],
  declarations: [
    AuditQueryComponent,
    AuditQueryHeaderComponent,
    AuditQueryGridComponent,
    AuditQueryGridRiskComponent,
    AuditQueryGridActionRiskComponent,
    AuditQueryChartComponent,
    AuditQueryChartRiskComponent,
    AuditPackageGenerateComponent,
    AuditPackageGenerateRiskComponent,
    AuditQueryGridFiltersComponent,
    AuditQueryGridActionComponent,
    AuditQueryItemReadinessComponent,
    AuditQueryItemUserRankRiskComponent,
  ],
  providers: [
    AuditQueryGridFiltersService,
    AuditQueryGridService,
    AuditQueryHeaderService,
    AuditQueryChartService,
    AuditPageEntryService,
    AuditPackageGenerateService,
    AuditPackageGenerateRiskService,
    AuditService,
    ChaseDetailStateService,
  ],
})
export class AuditModule { }
